import { useState } from 'react';
import { ModuleType } from '../../../lib/constants';
import { Lead } from '../lead/Lead';
import styles from './FloatingWidget.module.css'
import Image from "next/image";
import FloatIcon from '../../../public/assets/images/IncoFloat_icon.svg'
export function FloatingWidget() {
    const [isPopUp, togglePopUp] = useState(false);
    const [showTitle, setShowTitle] = useState(true);
    const [isThanks,setThanks]=useState(false)
    const popUpHandler=()=>{
        togglePopUp(!isPopUp);
    }
    return <>
        {isPopUp ? <div className="overlay">
            <div className="regFormBox popup">
            {!isThanks &&  <div className='closeModal' onClick={popUpHandler}>
                    <div className='leadFormClose'></div>
                </div>
            }
                <Lead ModuleType={ModuleType.INTERIOR} ButtonText="Book Free Consultation" Title="Meet the Designer" popUpHandler={popUpHandler} setThanks={setThanks}/>
            </div>
        </div> : null}
        <div className={styles.incoFloticon}>
            <span onClick={() => popUpHandler()} className={styles.flatIcoImg}>
                <Image
                    src={FloatIcon}
                    alt="Floating-Icon"
                    height={30}
                    loading='eager'
                    width={30}
                     />
            </span>
            {sessionStorage.getItem('isPopup') !== 'false' && showTitle && <div className={`${styles.title}`}>
                <div className={styles.headingBx}>
                    <p className="fbold text000">Need Free Consultation ?</p>
                    <div className={styles.closeIcon} onClick={() => {setShowTitle(false),sessionStorage.setItem('isPopup','false')}}></div>
                </div>
                <button className={styles.connectNow} onClick={() => popUpHandler()}>Book Now
                </button>
            </div>}
        </div>
    </>;

}